const queryString = require('query-string')
const in_array = require('in_array')
const generalEvents = require('../events/general-events')
const GlobalAlerts = require('global_alerts')
const Lang = require('lang');

function Bills() {
  nifty.body.overlay({ fixed: true });
  const modal = $('#modal-fatura');
  const modalContent = modal.find('.modal-content');

  const modalExcelFatura = $('#excel-fatura');
  const modalContentExcelFatura = modalExcelFatura.find('.modal-content');

  const modalPrevisaoFatura = $('#modal-previsao-fatura');
  const modalContentPrevisaoFatura = modalPrevisaoFatura.find('.modal-content');

  const modalUsuariosProdutos = $('#usuarios-produtos');
  const modalContentUsuariosProdutos = modalUsuariosProdutos.find('.modal-content');

  const modalProdutoUsuarios = $('#produto-usuarios');
  const modalContentProdutoUsuarios = modalProdutoUsuarios.find('.modal-content');

  const query = queryString.parse(location.search);

  const url = function (id) {
    return route('app.settings.financeiro.fatura', { idFatura: id })
  }
  const urlExcelFatura = function (id) {
    return route('app.settings.financeiro.excel-fatura', { idFatura: id })
  }

  const urlPrevisaoFatura = function (id) {
    return route('app.settings.financeiro.previsao-fatura', { idEmpresa: id })
  }

  const urlUsersProducts = function (id) {
    return route('app.settings.financeiro.users-products', { idFatura: id })
  }

  const urlProductUsers = function (idFatura, idProduto) {
    return route('app.settings.financeiro.product-users', {
      idFatura: idFatura,
      idProduto: idProduto
    })
  }

  const urlPrevisionProductUsers = function (idProduto, users) {
    return route('app.settings.financeiro.prediction-product-users', {
      idProduto: idProduto,
      users: users
    })
  }

  const urlPrevisionUsersProducts = function (id) {
    return route('app.settings.financeiro.prediction-users-products', {
      idEmpresa: id
    })
  }

  const openBillPrevision = function (id) {
    nifty.body.overlay('show')

    $.get(urlPrevisaoFatura(id))
      .done(function (html) {
        modalContentPrevisaoFatura.html(html);
        $.get(urlPrevisionUsersProducts(id))
          .done(function (html) {
            console.log(html)
            modalContentUsuariosProdutos.html(html);
          })
        modalPrevisaoFatura.modal('show');
        generalEvents();
      })
      .fail(function (error) {
        if (error.status === 404) {
          GlobalAlerts.createAndShow({
            title: Lang.get('js/src/functions/Bills.invoice_not_found'),
            message: Lang.get('js/src/functions/Bills.invoice_doesnt_exist'),
            type: 'danger',
            timer: 10000
          })
        } else if (error.status === 401) {
          location.reload();
        } else {
          GlobalAlerts.createAndShow({
            title: Lang.get('js/src/functions/Bills.ops'),
            message: Lang.get('js/src/functions/Bills.unexpected_error'),
            type: 'danger',
            timer: 10000
          })
        }
      })
      .always(function () {
        nifty.body.overlay('hide')
      });
  }

  const openBill = function (id) {
    nifty.body.overlay('show')

    $.get(url(id))
      .done(function (html) {
        $.get(urlExcelFatura(id))
          .done(function (html) {
            modalContentExcelFatura.html(html);
          });
        $.get(urlUsersProducts(id))
          .done(function (html) {
            modalContentUsuariosProdutos.html(html);
          })
        modalContent.html(html);
        modal.modal('show');
        generalEvents();
      })
      .fail(function (error) {
        if (error.status === 404) {
          GlobalAlerts.createAndShow({
            title: Lang.get('js/src/functions/Bills.invoice_not_found'),
            message: Lang.get('js/src/functions/Bills.invoice_doesnt_exist'),
            type: 'danger',
            timer: 10000
          })
        } else if (error.status === 401) {
          location.reload();
        } else {
          GlobalAlerts.createAndShow({
            title: Lang.get('js/src/functions/Bills.ops'),
            message: Lang.get('js/src/functions/Bills.unexpected_error'),
            type: 'danger',
            timer: 10000
          })
        }
      })
      .always(function () {
        nifty.body.overlay('hide')
      });
  }

  const openInvoiceProduct = function (idFatura, idProduto) {
    nifty.body.overlay('show')

    $.get(urlProductUsers(idFatura, idProduto))
      .done(function (html) {
        modalContentProdutoUsuarios.html(html);
      }).fail(function (error) {
        if (error.status === 404) {
          GlobalAlerts.createAndShow({
            title: Lang.get('js/src/functions/Bills.invoice_not_found'),
            message: Lang.get('js/src/functions/Bills.invoice_doesnt_exist'),
            type: 'danger',
            timer: 10000
          })
        } else if (error.status === 401) {
          location.reload();
        } else {
          GlobalAlerts.createAndShow({
            title: Lang.get('js/src/functions/Bills.ops'),
            message: Lang.get('js/src/functions/Bills.unexpected_error'),
            type: 'danger',
            timer: 10000
          })
        }
      })
      .always(function () {
        nifty.body.overlay('hide')
      });
  }

  const openPrevisionInvoiceProduct = function (idProduto, users) {
    nifty.body.overlay('show')

    $.get(urlPrevisionProductUsers(idProduto, users))
      .done(function (html) {
        modalContentProdutoUsuarios.html(html);
      }).fail(function (error) {
        if (error.status === 404) {
          GlobalAlerts.createAndShow({
            title: Lang.get('js/src/functions/Bills.invoice_not_found'),
            message: Lang.get('js/src/functions/Bills.invoice_doesnt_exist'),
            type: 'danger',
            timer: 10000
          })
        } else if (error.status === 401) {
          location.reload();
        } else {
          GlobalAlerts.createAndShow({
            title: Lang.get('js/src/functions/Bills.ops'),
            message: Lang.get('js/src/functions/Bills.unexpected_error'),
            type: 'danger',
            timer: 10000
          })
        }
      })
      .always(function () {
        nifty.body.overlay('hide')
      });
  }

  if (query.fatura) {
    document.addEventListener('DOMContentLoaded', function () {
      openBill(query.fatura)
    })
  }

  $('body').on('click', '[data-previsao]', function (e) {
    const idEmpresa = this.dataset.previsao;

    openBillPrevision(idEmpresa);
  })

  $('body').on('click', '[data-fatura]', function (e) {
    const id = this.dataset.fatura;
    const tagName = e.target.tagName.toLowerCase()

    if (in_array(tagName, ['a', 'button'])) {
      return true
    }

    openBill(id)
  })

  jQuery(function () {
    const urlParams = new URLSearchParams(window.location.search);
    const invoiceId = urlParams.get('invoice_id');

    if (invoiceId) {
      openBill(invoiceId);
    }
  })

  $('body').on('click', '[data-produto]', function (e) {
    const idProduto = this.dataset.produto;
    const idFatura = this.dataset.fatura;
    const users = this.dataset.users;

    if (idFatura) {
      openInvoiceProduct(idFatura, idProduto);
      return;
    }

    openPrevisionInvoiceProduct(idProduto, users)
  })

  const confirmInvoice = function (elementId) {
    $('#' + elementId).on('click', function (e) {
      const faturaID = e.target.dataset.faturaId

      bootbox.dialog({
        title: Lang.get('js/src/functions/Bills.generate_second_invoice'),
        message: Lang.get('js/src/functions/Bills.proceed_only_if_first_not_paid'),
        buttons: {
          cancel: {
            label: Lang.get('js/common/form/button.cancel'),
            className: 'btn-danger',
          },
          confirm: {
            label: Lang.get('js/common/form/button.confirm'),
            className: 'btn-success',
            callback: function () {
              location.href = route('app.settings.financeiro.segunda-via', faturaID)
            }
          }
        }
      });
    });
  }

  // Como o js executa no inicio mas precisa do onclick dentro do modal
  // fiz essa função pra ser executado no inicio e quando abrir o modal
  confirmInvoice('segunda-via-box');

  $('#modal-fatura').on('shown.bs.modal', function (e) {
    e.stopPropagation();
    confirmInvoice('segunda-via-modal');
  })

}

exports.init = Bills
